import { render } from "./Navbar.vue?vue&type=template&id=5fbb5a96&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=5fbb5a96&scoped=true&lang=scss"

import exportComponent from "/Users/andersnielsen/Sites/demo-leverandoroverblik/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbb5a96"]])

export default __exports__